<template>
  <div class="plastic-layer">
    <div class="plastic-layer__first-frame"></div>
    <div class="plastic-layer__holes"></div>

    <div class="plastic-layer__top">
      <img src="/logo-chervo.svg" alt="">
    </div>

    <div class="plastic-layer__bottom">
      <svg viewBox="0 0 57 61" fill="none" xmlns="http://www.w3.org/2000/svg" class="logo" data-v-551ac31b="" data-v-05ac45aa=""><path fill-rule="evenodd" fill="white" clip-rule="evenodd" d="M24.229 0.625029C30.742 1.19203 35.968 2.29203 38.838 4.70903C43.717 8.79903 43.028 12.475 40.03 15.145C37.685 17.245 33.984 18.681 31.056 19.458C37.1264 24.0106 42.3915 29.5475 46.633 35.839C52.219 44.139 54.953 49.993 56.715 59.539C56.7728 59.7227 56.7553 59.9218 56.6664 60.0926C56.5774 60.2633 56.4242 60.3917 56.2405 60.4495C56.0569 60.5073 55.8578 60.4898 55.687 60.4009C55.5163 60.3119 55.3878 60.1587 55.33 59.975C46.8417 41.2712 32.0498 26.1456 13.54 17.242C12.74 16.871 12.85 16.022 13.723 15.869C15.502 15.527 19.592 14.891 23.628 14.043C27.728 13.183 31.548 12.163 32.991 11.143C34.264 10.253 34.264 9.79903 32.502 9.05103C30.0423 8.18075 27.4697 7.67047 24.864 7.53603C20.303 7.18303 12.201 6.95903 3.38503 6.98803C3.15075 6.93422 2.93628 6.81572 2.76603 6.64603C1.60947 4.88119 0.694979 2.96913 0.0470323 0.961029C-0.00142471 0.850278 -0.0198894 0.728726 -0.00650756 0.60858C0.00687429 0.488435 0.0516316 0.373925 0.12327 0.27655C0.194908 0.179174 0.290906 0.102361 0.401622 0.053824C0.512339 0.00528689 0.633877 -0.0132657 0.754032 2.92594e-05C9.58703 0.0590293 17.683 0.0710292 24.229 0.625029Z" data-v-551ac31b=""></path></svg>
    </div>
  </div>
</template>

<script>
import gsap from 'gsap';

export default {
  name: 'PlasticLayer',

  data() {
    return {
      loaded: false,
      allowed: false,
    };
  },

  props: {
    background: {
      type: String,
      required: true,
    },
  },

  mounted() {
    gsap.set('.plastic-layer__top', { autoAlpha: 0, y: 30 });
    gsap.set('.plastic-layer__bottom', { autoAlpha: 0, y: -30 });

    window.addEventListener('tapped', () => {
      gsap.set('.plastic-layer__first-frame', {
        autoAlpha: 0,
      });
      gsap.to('.plastic-layer__holes', {
        y: '-100%',
        ease: 'power4.inOut',
        duration: 1.2,
      });
      gsap.to('.plastic-layer__bottom', {
        autoAlpha: 0,
      });
    });

    window.addEventListener('loaddone', () => {
      this.loaded = true;
      if (this.allowed) this.enterUI();
    });
    window.addEventListener('cameraallow', () => {
      this.allowed = true;
      if (this.loaded) this.enterUI();
    });
  },

  methods: {
    enterUI() {
      gsap.to('.plastic-layer__top', {
        y: 0,
        autoAlpha: 1,
        duration: 0.6,
      });
      gsap.to('.plastic-layer__bottom', {
        y: 0,
        autoAlpha: 1,
        duration: 0.6,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.plastic-layer {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100%;

  &__first-frame,
  &__holes {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-position: center center;
    background-size: cover;

    z-index: 3;
  }

  &__first-frame {
    background-image: url('/bg.jpg');
  }

  &__holes {
    // background-image: url('/holes.png');
    background-color: #09473a;
  }

  &__top {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px 0px;

    z-index: 5;
  }

  &__bottom {
    position: absolute;
    width: 100%;
    height: 10vh;
    bottom: 0;
    left: 0;
    padding: 10px 0px;

    color: white;
    text-align: center;

    font-size: 0.8em;

    z-index: 5;

    display: flex;
    align-items: center;
    justify-content: center;

    svg {
      height: 50%;
    }
  }
}
</style>
